import { LiveProps } from 'src/pages/CommunityDetails/Posts/live'
import { FailureReason } from 'src/components/postCommentInput/hooks'
import type { PermissionActions } from 'src/services/posts'
import { PostStatus } from './enums'

export type MembershipInfoProps = {
  membershipId: string
  courseId?: number
  lessonHash?: string
  courseTag?: string
}

export type OwnerCollectionsPermissionsGroup =
  | 'OWNER'
  | 'ADMIN'
  | 'MODERATOR'
  | 'FOLLOWER'
  | 'VIEWER'

export type OwnerCollectionsPermissions = {
  group: OwnerCollectionsPermissionsGroup
  actions?: PermissionActions[]
}

export type PostProps = {
  id: number
  authorName: string
  authorHasImage: boolean
  authorMemberType: string
  title: string
  pubDate: number
  isAuthor: boolean
  postType: number
  authorId: number
  membershipInfo: MembershipInfoProps
  authorUcode?: string
  ownerCollectionName?: string
  isFixed?: boolean
  link?: string
  description?: string
  richDescription?: string
  canUserComment?: boolean
  mostRecentCommentDate?: number
  authorImagePath?: string
  authorImageFinalUrl?: string
  mediaHeight?: number
  mediaWidth?: number
  commentsCount?: number
  isCommentsEnabled?: boolean
  communityId?: number
  content?: string
  domainURL?: string
  domainImage?: string
  hasUnseenReactions?: boolean
  reactions?: Reaction[]
  ownerCollectionId?: number
  ownerCollectionPermissions?: OwnerCollectionsPermissions
  scheduledPubDate?: string
  scheduledPubTimeZoneId?: string
  live?: LiveProps
  authorFeaturedMemberRank?: number
  trending?: boolean
  viewsCount?: number
  mentions?: MentionProps[]
  commentAuthorsPreview?: { ucode: string }[]
  postStatus?: PostStatus
  hasUnseenMentionInComments?: boolean
}

export type Reaction = {
  reactionCode: string
  count: number
  reactedByUser: boolean
}

export type MentionProps = {
  tag: string
  failed: boolean
  failureReason?: FailureReason
  metadata?: {
    ucode?: string
    name?: string
    me?: boolean
  }
}

export enum FeedEventNames {
  POST_CREATED = 'app-membership-consume:post-created',
  POST_UPDATED = 'app-membership-consume:post-updated',
  POST_DELETED = 'app-membership-consume:post-deleted',
  POST_VIEWED = 'app-membership-consume:post-viewed',
  SCHEDULED_POST_CREATED = 'app-membership-consume:scheduled-post-created',
  POST_PINNED = 'app-membership-consume:post-pinned',
  POST_UNPINNED = 'app-membership-consume:post-unpinned',
  POST_REACTION = 'app-membership-consume:post-reaction',
  COMMENT_CREATED = 'app-membership-consume:comment-created',
  COMMENT_BLOCKED = 'app-membership-consume:comment-blocked',
  COMMENT_UNBLOCKED = 'app-membership-consume:comment-unblocked'
}
